<template>
        <div class="personal__form">
            <div class="personal__form-title">Смена пароля</div>
            <form @submit.prevent="validate" class="form form--password" name="change_password">
                <div class="form__inputs form__inputs--2">
                    <div class="custom-input">
                        <input @input="this.reset" autocomplete="off" class="custom-input__input" type="password" name="password"
                               v-bind:class="{'custom-input__input--error':errors.some(er => er.code === 2)}"
                               v-model="password" placeholder="Введите пароль">
                        <span v-if="errors.some(er => er.code === 2)" class="custom-input__error"></span>
                        <label class="custom-input__label">Новый пароль </label>
                    </div>
                    <div class="custom-input">
                        <input @input="this.reset" autocomplete="off" class="custom-input__input" type="password" name="confirm"
                               v-bind:class="{'custom-input__input--error':errors.some(er => er.code === 3)}"
                               v-model="confirm" placeholder="Повторите пароль">
                        <span v-if="errors.some(er => er.code === 3)" class="custom-input__error"></span>
                        <label class="custom-input__label">Подтвердить пароль</label>
                    </div>
                    <div style="display: none">
                        <vue-recaptcha
                            ref="recaptcha"
                            size="invisible"
                            :sitekey="this.site_key"
                            @verify="sendData"
                            @expired="onCaptchaExpired"
                        />
                    </div>
                </div>
                <input class="btn" name="sendPass" type="submit" value="Сохранить изменения"/>
            </form>
        </div>
</template>

<script>
import recaptcha from "@/components/mixins/recaptcha";
import errors from "@/components/mixins/errors";
import tools from "@/components/mixins/tools";

export default {
    name  : "PersonalPassword",
    mixins: [recaptcha, errors, tools],
    data()
    {
        return {
            password: '',
            confirm : ''
        }
    },
    methods: {
        sendData(recaptchaToken)
        {
            this.reset();
            let formData = new FormData();
            formData.append('token', recaptchaToken);
            formData.append('password', this.password);
            formData.append('confirm', this.confirm);
            fetch("/api/user/update/", {method: 'POST', body: formData}).
                then(response => response.json()).
                then(async resp =>
                     {
                         if(resp.success !== true)
                         {
                             let errs = JSON.parse(resp.message);
                             this.parse(errs);
                         }
                         else
                         {
                             window.toast.success('Личный кабинет', 'Изменения успешно сохранены.');
                             this.password = '';
                             this.confirm  = '';
                         }
                     });
        },
    },
}
</script>

<style scoped>

</style>